import {
  CANCEL_ORDER_LOADING,
  CLOSE_CANCEL_ORDER_ALERT,
  CANCEL_ORDER_RESPONSE,
  SET_OTHER_REASON, SET_SELECTED_REASON,
  ORDER_CLOSURE_REASONS_SUCCESS,
  OPEN_CANCEL_ORDER_DIALOG,
  CLOSE_CANCEL_ORDER_DIALOG,
} from 'constants/ActionTypes';

const initValues = {
  cancelReportID: null,
  cancelReportAddress: '',
  cancelOrderStatus: '',
  selectedReason: '',
  otherReason: '',
  cancelOrderLoading: false,
};

const initState = {
  closureReasons: [],
  ...initValues,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case ORDER_CLOSURE_REASONS_SUCCESS: return { ...state, closureReasons: action.closureReasons };
    case OPEN_CANCEL_ORDER_DIALOG: return {
      ...state, cancelReportID: action.cancelReportID, cancelReportAddress: action.cancelReportAddress, cancelOrderStatus: '',
    };
    case CLOSE_CANCEL_ORDER_DIALOG: return { ...state, ...initValues };
    case SET_SELECTED_REASON: return { ...state, selectedReason: action.selectedReason };
    case SET_OTHER_REASON: return { ...state, otherReason: action.otherReason };
    case CANCEL_ORDER_RESPONSE: return {
      ...state, ...initValues, cancelOrderStatus: action.responseStatus, cancelOrderLoading: false,
    };
    case CLOSE_CANCEL_ORDER_ALERT: return { ...state, cancelOrderStatus: '' };
    case CANCEL_ORDER_LOADING: return { ...state, cancelOrderLoading: true };
    default: return state;
  }
};
